export const DEFAULT_LOCAL_STORAGE = "{\"Limit\":10,\"Offset\":0}"

/** IDs des pays considérés comme "France ou assimilé" (France métropolitaine + DOM/TOM/Collectivités d'outre-mer)
 * 74=France, 79=Guyane française, 86=Guadeloupe, 147=Martinique, 158=Nouvelle-Calédonie,
 * 172=Polynésie française, 177=Saint-Pierre-et-Miquelon, 185=Réunion,
 * 210=Terres australes françaises, 237=Wallis et Futuna, 240=Mayotte,
 * 415=Saint-Barthélemy, 418=Saint-Martin (partie française)
 */
export const FRANCE_ET_ASSIMILES_IDS: number[] = [74, 79, 86, 147, 158, 172, 177, 185, 210, 237, 240, 415, 418];
export const DEFAULT_LOCAL_STORAGE_SORT = "{}"
export const passwordRegex =
  // eslint-disable-next-line no-useless-escape
  /(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[$!*#?&+\-=@^_()\/\\€%]).{8,}/ 
  ///(?!.*?%)(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[$!*#?&+\-=@^_()\/\\€]).{8,}/; //==>interdit le %

  export const formatDate2 = "yyyy-MM-dd";//"DD/MM/YYYY";
  export const formatDate = "DD/MM/YYYY";
  export const formatDate_fns = "dd/MM/yyyy";
  export const formatDateHeure = "DD/MM/YYYY HH:mm:ss";//"dd/MM/yyyy HH:mm:ss";//"DD/MM/YYYY HH:mm:ss";
  export const formatDateHeure_fns = "dd/MM/yyyy HH:mm:ss";

  // const regex = new RegExp(
  //   "([0-9]{4}[-](0[1-9]|1[0-2])[-]([0-2]{1}[0-9]{1}|3[0-1]{1})|([0-2]{1}[0-9]{1}|3[0-1]{1})[-](0[1-9]|1[0-2])[-][0-9]{4})"
  // );

  export const regexDate = new RegExp(
    "^(?:[0-9]{4}[-](0[1-9]|1[0-2])[-]([0-2]{1}[0-9]{1}|3[0-1]{1})|(0[1-9]|[12][0-9]|3[01])[-](0[1-9]|1[0-2])[-][0-9]{4})$"
  );
  /* eslint-disable no-useless-escape*/
  export const regexDateHeure = new RegExp(
    "^(?:(?:[0-9]{4}[-](0[1-9]|1[0-2])[-]([0-2]{1}[0-9]{1}|3[0-1]{1})|(0[1-9]|[12][0-9]|3[01])[-](0[1-9]|1[0-2])[-][0-9]{4})\s+(?:([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9])|(?:(?:[0-9]{4}[-](0[1-9]|1[0-2])[-]([0-2]{1}[0-9]{1}|3[0-1]{1})|(0[1-9]|[12][0-9]|3[01])[-](0[1-9]|1[0-2])[-][0-9]{4})T(?:([01][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9])(?:\.[0-9]+)?))$"
  );

  
